import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { projectAvailabilityApi } from "@/services/projectAvailabilityApi";

const KEY = ["project-availability"];

export function useProjectAvailability() {
  return useQuery({
    queryKey: KEY,
    queryFn: projectAvailabilityApi.list,
    retry: false,
  });
}

export function useSetProjectAvailability() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ projectId, appId, available }: { projectId: string; appId: string; available: boolean }) =>
      available ? projectAvailabilityApi.share(projectId, appId) : projectAvailabilityApi.unshare(projectId, appId),
    onSettled: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}
